import { Injectable } from "@angular/core";
import { connectBundles } from "ngrx-action-bundles";
import { notificationBundles } from "./bundles";

@Injectable({ providedIn: "root" })
export class NotificationModel {
  actions = connectBundles(notificationBundles);
}
